/**
 * This is only used for the renewal settings for premium users now. It's replaced with
 * AccountPanelView2 for users who haven't yet upgraded.
 */

import Backbone from "backbone";
import $ from "jquery";
import * as _ from "underscore";

import compositeViewMixin from "compositeViewMixin";
import * as localAPI from "localAPI";
import * as modalDialog from "modalDialog";
import * as mustcache from "mustcache";
import readlangClient from "readlangClient";
import * as dateUtils from "shared/dateUtils";
import * as subscriptionPlans from "shared/subscriptionPlans";
import * as signupModal from "signupModal";
import * as upsellTimer from "upsellTimer";
import AccountRenewalView from "views/AccountRenewalView";

const isBookmarklet = window.location.pathname === "/bookmarklet";

const AccountPanelView = Backbone.View.extend({
  initialize: function (options) {
    _.extend(this, compositeViewMixin);

    this.options = _.defaults(options, {
      showTitle: true,
    });
    upsellTimer.reset();
    this.render();
  },
  render: async function () {
    const data: { [key: string]: any } = {};

    switch (this.model.get("subscriptionPlan")) {
      case "freeForever":
        data.freeForever = true;
        break;
      case "standard":
        data.standard = true;
        break;
      case "plus":
        data.plus = true;
        break;
      default:
        data.free = true;
    }

    data.user = this.model.toJSON();
    data.expiryDate = new Date(
      dateUtils.parse(this.model.get("subscriptionExpiryDate"))
    );
    data.expiryDateString = data.expiryDate.toDateString();
    data.plans = subscriptionPlans.plans;
    data.permissions = subscriptionPlans.permissions;
    data.encodedSharingURL = encodeURIComponent(
      "https://readlang.com/?ref=" + data.user._id
    );
    data.encodedSharingText = encodeURIComponent(
      "Great way to read and learn foreign languages"
    );
    data.encodedEmailBody =
      encodeURIComponent(
        "Awesome site for reading in foreign languages, " +
          "and you can get a higher usage limit for free with this link:\n\n"
      ) + data.encodedSharingURL;

    if (this.options.socialButtons) {
      data.socialButtons = true;
    }
    if (this.options.accountPage) {
      data.accountPage = true;
    }
    if (await localAPI.isLocalMode()) {
      data.localMode = true;
    }

    if (this.options.phraseLimit) {
      const acheivements = this.model.get("acheivements") || [];
      if (acheivements.indexOf("extraPhrases") === -1) {
        // DISABLE extra phrases
        data.extraPhrases = true;
      }
      data.phraseLimit =
        data.user.phraseLimit || subscriptionPlans.permissions.free.phrases;
    }
    if (this.options.allPhrasesLimit) {
      data.allPhrasesLimit = true;
    }

    if (this.model.get("renewalMonths") > 0 && this.model.get("price")) {
      data["priceOverride" + this.model.get("renewalMonths")] =
        this.model.get("price");
    }

    if (this.options.heading) {
      data.heading = this.options.heading;
    }

    data.splitTests = window.READLANG && window.READLANG.splitTests;

    if (this.options.showTitle) {
      data.showTitle = true;
    }

    if (this.options.smartDefinitions) {
      data.smartDefinitions = true;
      data.smartDefinitionsLimit =
        subscriptionPlans.permissions.free.definitions;
    }

    if (isBookmarklet) {
      data.bookmarklet = true;
    }

    mustcache.render("account", data, (html) => {
      this.$el.html(html);
      if (
        this.model.get("subscriptionPlan") === "standard" ||
        this.model.get("plus")
      ) {
        this.setSubviews({
          renewalView: new AccountRenewalView({
            el: this.$('[data-subview="renewalView"]'),
            model: this.model,
          }),
        });
      }
    });
  },
  events: {
    "click .goToCheckout": "goToCheckout",
    "click .loginLink": "loginLink",
    "click .signupLink": "signupLink",
    "click .extraPhrases": "extraPhrases",
    "click .continue": "continue",
  },
  goToCheckout: function (event) {
    if (isBookmarklet) {
      event.preventDefault();
      event.stopPropagation();

      // Ensure the checkout page loads in a new tab, because otherwise it'll appear awkwardly
      // within the iframe
      const protocol =
        window.location.hostname === "localhost" ? "http://" : "https://";
      window.top.location.href = protocol + window.location.host + "/checkout";
      return;
    }
  },
  loginLink: function (event) {
    event.preventDefault();
    event.stopPropagation();
    $("#loginButton").click();
  },

  signupLink: function (event) {
    event.preventDefault();
    event.stopPropagation();
    signupModal.show({
      models: {
        user: this.model,
      },
    });
  },

  extraPhrases: function () {
    this.$(".extraPhrases").after($('<img src="/content/throbber.gif"></img>'));
    this.$(".extraPhrases").hide();
    readlangClient.request("POST", "/api/user/claimExtraPhrases", {}, () => {
      const acheivements = this.model.get("acheivements") || [];
      if (acheivements.indexOf("extraPhrases") === -1) {
        acheivements.push("extraPhrases");
      }
      this.model.set("acheivements", acheivements);
      modalDialog.cancel();
    });
  },

  continue: function () {
    modalDialog.cancel();
  },
});

export default AccountPanelView;
